var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("title"),(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.close)?_c('i',{staticClass:"el-icon-close",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }